<template>
    <div style="height: 100%">
        <div id="entrance">
            <div class="title">
                <img src="../assets/image/entrance/title.png" alt="" />
            </div>
            <!-- <div class="linshi" style="width: 100%">
                平台:<input class="pingtai" type="text" v-model="pingtai" /> ID:<input
                    class="userId"
                    type="text"
                    v-model="userId"
                />
                <div @click="sreach(pingtai, userId)">搜索</div>
            </div> -->
            <div class="btn" v-if="isIosOrAndroid != 'android'">
                <div class="top">
                    <div @click="btn('steam')" class="box steam">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/steam.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div>
                </div>
                <div class="bottom">
                    <div @click="btn('psn')" class="box psn">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/psn.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div>
                    <!-- <div @click="btn('xbox')" class="box xbox">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/steam.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div> -->
                    <div @click="btn('epic')" class="box epic">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/epic.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div>
                </div>
            </div>

            <div class="btn and_btn" v-else>
                <div class="and_box">
                    <div @click="btn('steam')" class="box steam">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/steam.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div>
                    <div @click="btn('psn')" class="box psn">
                        <div class="l"></div>
                        <div class="m">
                            <img src="../assets/image/entrance/psn.png" alt="" />
                        </div>
                        <div class="r"></div>
                    </div>
                </div>
            </div>

            <div class="entrance-comment">
                <span class="tit" @click.self="toCommentReport">社区分享年度报告，赢取北通手柄<i></i></span>
            </div>

            <div id="dialog" v-if="showDialog">
                <div class="biaoti">温馨提示</div>
                <div class="tishi">
                    为了保证数据准确，请先前往Epic名片页点击右上角刷新最新数据后再返回查看(App-我的-Epic名片)。(因可能存在数据延迟，若刷新后仍弹本提示，请稍等几分钟后重试)
                </div>
                <div class="dialogBtn">
                    <span @click="showDialog = false">我知道了</span>
                </div>
            </div>
            <div class="mode" v-if="showDialog"></div>
        </div>

        <transition name="fade">
            <gs-app-compont-commont></gs-app-compont-commont>
        </transition>
    </div>
</template>
<script>
var _bdhmProtocol = "https:" == document.location.protocol ? " https://" : " //";
document.write(
    unescape(
        "%3Cscript src='" + _bdhmProtocol + "hm.baidu.com/h.js%3Fdcb5060fba0123ff56d253331f28db6a' %3E%3C/script%3E"
    )
);
</script>
<script>
import GsAppCompontCommont from "../components/GsAppCompont_Commont.vue";
import report from "../api/index.js";
export default {
    name: "entrance",
    components: { GsAppCompontCommont },
    data() {
        return {
            isIosOrAndroid: "",
            pingtai: "",
            userId: null,
            showDialog: false
        };
    },
    created() {
        this.finishActivity();
    },
    mounted() {
        GSAppJsApi.UMeng.recordEvent("enter_annual_report", 0);
        GSAppJsApi.EventStatistics.recordEvent("B19101_进入年报引导页面的用户数", {}, 0);

        GSAppJsApi.UI.setBrowserUI("Light", true, true);


        
    },

    methods: {
        toCommentReport() {
            // 友盟统计
            GSAppJsApi.UMeng.recordEvent("annual_community_click", 0);
            // 事件统计
            GSAppJsApi.EventStatistics.recordEvent("B19110_年报社区引导按钮点击人数", {}, 0);

            this.$utils.openWithNewWindow("https://club.gamersky.com/activity/989691?club=2");
        },
        sreach(pingtai, id) {
            this.getType(pingtai, id);
        },

        finishActivity() {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                this.isIosOrAndroid = "ios";
            } else {
                this.isIosOrAndroid = "android";
            }
        },

        isShowPage(type) {
            let that = this;
            if (that.isIosOrAndroid == "android") {
                if (GSAppJsApi.Environment.isInAppWebViewInAndroid()) {
                    that.getUserInfo(type);
                } else {
                    that.downloadApp();
                }
            } else {
                if (GSAppJsApi.Environment.isInAppWebViewInIOS()) {
                    that.getUserInfo(type);
                } else {
                    that.downloadApp();
                }
            }

            // this.getUserInfo(type)
        },

        getUserInfo(type) {
            let that = this;
            if (GSAppJsApi.User.getCurrentUser() != null) {
                that.$ajax
                    .get("//router.gamersky.com/@/user/getUserInfoForYearReport/6.0.0/GSAPP_iOS", {
                        objectUserId: GSAppJsApi.User.getCurrentUserId()
                        // objectUserId:6557671
                    })
                    .then(res => {
                        let data = {
                            deviceType: "iPhone7,2",
                            deviceId: "61BCED9D-EEE9-4F20-A197-5EF9BE079889",

                            os: "iOS",
                            osVersion: "12.5.5",
                            app: "GSApp(iOS)",
                            appVersion: "5.16.1",
                            request: {
                                userId: GSAppJsApi.User.getCurrentUserId()
                            }
                        };

                        switch (type) {
                            case "steam":
                                if (res.user.steamAccountBound) {
                                    that.getType(type);
                                } else {
                                    let a = document.createElement("a");
                                    a.href =
                                        "https://app.gamersky.com/zt/24annual/report?type=steam&gsAppPageName=woDe_BangDingSteam&yearReport=steam";
                                        // "https://project-test.gamersky.com/2024report/#/report?type=steam&gsAppPageName=woDe_BangDingSteam&yearReport=steam";
                                    a.click();
                                }
                                break;
                            case "psn":
                                if (res.user.psnaccountBound) {
                                    that.getType(type);
                                } else {
                                    let a = document.createElement("a");
                                    a.href =
                                        "https://app.gamersky.com/zt/24annual/report?type=psn&gsAppPageName=woDe_BangDingPSN&yearReport=psn";
                                        // "https://project-test.gamersky.com/2024report/#/report?type=psn&gsAppPageName=woDe_BangDingPSN&yearReport=psn";
                                    a.click();
                                }
                                break;
                            case "xbox":
                                that.$ajax
                                    .post(
                                        "//appapi2.gamersky.com/v5/getUserInfesList/",
                                        JSON.stringify({
                                            deviceType: "x86_64",
                                            deviceId: "A6D2DD48-E3A8-4E1D-A9E3-40A4096B8FAC",
                                            os: "iOS",
                                            osVersion: "11.2",
                                            app: "GSApp",
                                            appVersion: "3.7.1",
                                            request: {
                                                userIds: GSAppJsApi.User.getCurrentUserId(),
                                                cacheMinutes: 10
                                            }
                                        })
                                    )
                                    .then(res => {
                                        if (res.errorCode == 0) {
                                            if (res.result[0].xBoxAccount != "") {
                                                that.getType(type);
                                            } else {
                                                let a = document.createElement("a");
                                                a.href =
                                                    "https://app.gamersky.com/zt/24annual/report?type=xbox&gsAppPageName=woDe_BangDingXBL&yearReport=xbox";
                                                    // "https://project-test.gamersky.com/2024report/#/report?type=xbox&gsAppPageName=woDe_BangDingXBL&yearReport=xbox";
                                                a.click();
                                            }
                                        }
                                    });

                                break;
                            case "epic":
                                // if (res.user.epicAccount && res.user.epicAccount != "") {
                                //     that.getType(type);
                                // } else {
                                //     let a = document.createElement("a");
                                //     a.href =
                                //         "https://app.gamersky.com/zt/24annual/report?type=epic&gsAppPageName=woDe_BangDingEPIC&yearReport=epic";
                                //     a.click();
                                // }

                                that.$ajax
                                    .post(
                                        "//router.gamersky.com/@/epic/getCardInfoForEpicReport/6.0.0/" +
                                            GSAppJsApi.User.getCurrentUserId() +
                                            "/GSAPP_iOS"
                                    )
                                    .then(res => {
                                        if (res.epicId && res.epicId != "") {
                                            // if (res.isNeedRefresh) {
                                            //     that.showDialog = true;
                                            // } else {
                                            //     that.getType(type);
                                            // }
                                            let isNeedRefresh =
                                                res.isNeedRefresh ||
                                                new Date(res.updateTime) < new Date("2024-12-19T00:00:00");
                                            if (isNeedRefresh) {
                                                that.showDialog = true;
                                            } else {
                                                that.getType(type);
                                            }
                                        } else {
                                            let a = document.createElement("a");
                                            a.href =
                                                "https://app.gamersky.com/zt/24annual/report?type=epic&gsAppPageName=woDe_BangDingEPIC&yearReport=epic";
                                                // "https://project-test.gamersky.com/2024report/#/report?type=epic&gsAppPageName=woDe_BangDingEPIC&yearReport=epic";
                                            a.click();
                                        }
                                    });
                        }
                    });
            } else {
                GSAppJsApi.User.loginTo();
            }
        },

        downloadApp() {
            GSAppJsApi.Net.download(
                "http://hey.scandown.com/7ksb",
                function (response) {},
                function (result) {
                    window.location.href = "https://app.gamersky.com/toApp/";
                }
            );
        },

        getType(type) {
            switch (type) {
                case "steam":
                    // this.$router.push({
                    //     name: "report",
                    //     query: {
                    //         type: "steam",
                    //         id: this.userId,
                    //         appstatusbarstyle: "kLightBar"
                    //     }
                    // });
                    let steam = document.createElement("a");
                    steam.href ="https://app.gamersky.com/zt/24annual/#/report?type=steam&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    steam.href =
                        // "https://project-test.gamersky.com/2024report/#/report?type=steam&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    steam.click();
                    break;
                case "psn":
                    // this.$router.push({
                    //     name: "report",
                    //     query: {
                    //         type: "psn",
                    //         id: this.userId,
                    //         appstatusbarstyle: "kLightBar"
                    //     }
                    // });
                    let psn = document.createElement("a");
                    psn.href ="https://app.gamersky.com/zt/24annual/#/report?type=psn&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    psn.href =
                        // "https://project-test.gamersky.com/2024report/#/report?type=psn&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    psn.click();
                    break;
                case "xbox":
                    // this.$router.push({
                    //     name: "report",
                    //     query: {
                    //         type: "xbox",
                    //         id: this.userId,
                    //         appstatusbarstyle: "kLightBar"
                    //     }
                    // });
                    let xbox = document.createElement("a");
                    xbox.href ="https://app.gamersky.com/zt/24annual/#/report?type=xbox&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    xbox.href =
                        // "https://project-test.gamersky.com/2024report/#/report?type=xbox&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    xbox.click();
                    break;
                case "epic":
                    // this.$router.push({
                    //     name: "report",
                    //     query: {
                    //         type: "epic",
                    //         id: this.userId,
                    //         appstatusbarstyle: "kLightBar"
                    //     }
                    // });

                    let epic = document.createElement("a");
                    epic.href ="https://app.gamersky.com/zt/24annual/#/report?type=epic&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    epic.href =
                        // "https://project-test.gamersky.com/2024report/#/report?type=epic&appstatusbarstyle=kLightBar&appnavigationbarstyle=knonebar";
                    epic.click();
                    break;
            }
        },

        btn(type) {
            this.isShowPage(type);
        }
    }
};
</script>

<style>
body {
    background: #060815;
}

.linshi {
    text-align: center;
    margin-bottom: 50px;
    color: #fff;
    position: absolute;
    top: 20rem;
}

.linshi > div {
    width: 50px;
    height: 30px;
    margin: 0 auto;
    margin-top: 10px;
    border: 1px solid #fff;
    line-height: 30px;
}

.linshi > input {
    width: 100px;
    height: 30px;
    background: #fff;
    display: inline-block;
}

.linshi .pingtai {
    margin-right: 30px;
}

#entrance {
    width: 100%;
    height: 100%;
    min-height: 42.2rem;
    overflow: hidden;
    background: url("../assets/image/entrance/bg.png") no-repeat;
    background-size: 100%;
    position: relative;
}

#entrance .title {
    width: 16.7rem;
    height: 4.9rem;
    margin: 0 auto;
    margin-top: 5rem;
}

#entrance .title img {
    width: 100%;
    height: 100%;
    display: block;
}

#entrance .btn {
    margin-top: 16.5rem;
}
#entrance .btn .top {
    margin: 0 1.3rem;
}
#entrance .btn .bottom {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    /* gap: 0.92rem; */
    margin-top: 0.61rem;
}


#entrance .btn .box {
    width: 7.95rem;
    height: 3.25rem;
    display: flex;
    justify-content: center;
}
#entrance .btn .epic{
    margin-left: 0.92rem;
}
#entrance .btn .top .steam {
    margin: 0 auto;
    width: 100%;
}
#entrance .and_btn{
    margin-top: 18rem;
}
#entrance .and_btn .and_box{
    display: flex;
    justify-content: center;
    /* gap: 0.92rem; */
}
#entrance .and_btn .and_box .psn{
    margin-left: 0.92rem;
}
#entrance .btn .steam .l {
    background: url("../assets/image/entrance/steam_l.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}
#entrance .btn .steam .m {
    flex: 1;
    height: 3.25rem;
    background-image: url("../assets/image/entrance/steam_m.png");
    background-repeat: repeat-x;
    background-size: auto 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
#entrance .btn .steam .r {
    background: url("../assets/image/entrance/steam_r.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}
#entrance .btn .psn .l {
    background: url("../assets/image/entrance/psn_l.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}
#entrance .btn .psn .m {
    flex: 1;
    height: 3.25rem;
    background-image: url("../assets/image/entrance/psn_m.png");
    background-repeat: repeat-x;
    background-size: auto 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
#entrance .btn .psn .r {
    background: url("../assets/image/entrance/psn_r.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}

#entrance .btn .epic .l {
    background: url("../assets/image/entrance/epic_l.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}
#entrance .btn .epic .m {
    flex: 1;
    height: 3.25rem;
    background-image: url("../assets/image/entrance/epic_m.png");
    background-repeat: repeat-x;
    background-size: auto 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
#entrance .btn .epic .r {
    background: url("../assets/image/entrance/epic_r.png") no-repeat;
    background-size: cover;
    width: 1.03rem;
    height: 3.25rem;
}

#entrance .btn .steam img {
    width: 5.29rem;
    height: 1.66rem;
}
#entrance .btn .psn img {
    width: 4.04rem;
    height: 1.66rem;
}
#entrance .btn .epic img {
    width: 4.15rem;
    height: 1.66rem;
}

#entrance .txt {
    font-size: 18px;
    font-family: zixiaohunheijinti;
    color: #ffffff;
    text-align: right;
    /* margin-right: 1.6rem; */
}

#entrance .txt img {
    width: 8.3rem;
    height: 0.55rem;
}

.entrance-comment {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 3.5rem;
    left: 50%;
    margin-left: -133px;
}

.entrance-comment .tit {
    width: 266px;
    height: 27px;
    text-align: center;
    line-height: 27px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
}

.entrance-comment .tit i {
    display: inline-block;
    margin-left: 5px;
    width: 10px;
    height: 10px;
    background: url("../assets/image/entrance/rightArrow.png") no-repeat center / 10px 10px;
}
.emojiIcon {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: middle;
}

#dialog {
    /* display: none; */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    background: #fff;
    border-radius: 6px;
    text-align: center;
    z-index: 9999;
}
.mode {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}
#dialog .biaoti {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    padding-top: 16px;
}
#dialog .tishi {
    padding: 0 16px;
}
#dialog .dialogBtn {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #e5e7e9;
}
#dialog .dialogBtn span {
    height: 36px;
    line-height: 36px;
    width: 100%;
}
</style>
​​
